import React from 'react';
import Datepicker from './Datepicker';

class CalencarComponent extends React.Component {
  state = {
    selectedDate: null,
    date: new Date(),
    firstDayOfWeek: 0,
    showOutsideDays: false
  };




  _handleFirstDayOfWeek = firstDayOfWeek => {
    this.setState(state => ({
      firstDayOfWeek
    }));
  };

  _handleShowOutsideDays = () => {
    this.setState(state => ({
      showOutsideDays: !state.showOutsideDays
    }));
  };

  _handleOnDateSelected = ({ selected, selectable, date }) => {
    if (!selectable) {
      return;
    }
    this.setState(state => {
      let newDate = date;
      if (
        state.selectedDate &&
        state.selectedDate.getTime() === date.getTime()
      ) {
        newDate = null;
      }
      return { selectedDate: newDate };
    });
  };

  render() {
    let { selectedDate, date, firstDayOfWeek, showOutsideDays } = this.state;
    return (

     
      <div className="elegant-calencar" dir="auto">
    <div className="calendar-wrapper" id="calendar"> 
     {/* <div className="popup-notification">
             <h4>اليوم العالمي للرجل</h4>
             <img src="/static/img/notification2.png" alt="img" className="img-fluid" />
         </div> */}
  
         <Datepicker
          date={date}
          selected={selectedDate}
          firstDayOfWeek={firstDayOfWeek}
          showOutsideDays={false}
          onDateSelected={this._handleOnDateSelected}
        />
       
       
  
  
    
  </div>
    </div>




    
    );
  }
}

export default CalencarComponent;